export const size = {
    pcMaxWidth: '1420px'
};